/**
 * UI Constants for consistent styling across components
 * 
 * This file centralizes magic numbers and hardcoded values to improve
 * maintainability and ensure consistency across the application.
 */

export const UI_CONSTANTS = {
  // Button sizes
  BUTTONS: {
    MEDIUM_SIZE: 44,
    SMALL_HEIGHT: 28,
  },
  
  // Typography
  TYPOGRAPHY: {
    SMALL_FONT: '0.7rem',
    CAPTION_FONT: '0.65rem',
    FONT_WEIGHT_MEDIUM: 500,
  },
  
  // Spacing
  SPACING: {
    RIGHT_GAP: '20px',
    PANEL_PADDING: 2,
    BORDER_RADIUS: 4,
    SMALL_GAP: 1,
    LARGE_GAP: 3,
  },
  
  // Shadows (matching CMChip)
  SHADOWS: {
    DEFAULT: '0 2px 4px rgba(0, 0, 0, 0.1)',
    HOVER: '0 3px 6px rgba(0, 0, 0, 0.1)',
    ENHANCED: '0 8px 32px rgba(0, 0, 0, 0.1)',
    GLASS_DARK: '0 8px 32px 0 rgba(0, 0, 0, 0.37)',
    GLASS_LIGHT: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
  },
  
  // Status bar
  STATUS_BAR: {
    MIN_HEIGHT_SMALL: '40px',
    MIN_HEIGHT_LARGE: '48px',
  },
  
  // Layout dimensions
  LAYOUT: {
    THUMBNAIL_SIZE: 60,
    CARD_HEIGHT_COMPACT: 120,
    CARD_HEIGHT_FULL: 400,
    MIN_ITEM_WIDTH_COMPACT: 120,
    MIN_ITEM_WIDTH_FULL: 300,
    TABLE_MIN_WIDTH: 800,
    TABLE_CELL_MIN_WIDTH: '150px',
    SCROLL_THRESHOLD: 200,
    INDICATOR_SIZE: 8,
  },
  
  // Z-indexes
  Z_INDEX: {
    ENDPOINT_BUTTONS: 2000000,
    LOADING_OVERLAY: 1200,
    TOGGLE_BUTTON: 10,
  },
  
  // Colors and opacity
  COLORS: {
    GLASS_BACKGROUND_OPACITY: 0.1,
    BACKDROP_BLUR: 'blur(10px)',
    SUBTLE_BORDER: 'rgba(255, 255, 255, 0.1)',
    SUBTLE_BACKGROUND: 'rgba(255, 255, 255, 0.1)',
    WHITE_BORDER: '1px solid white',
    BLACK_BORDER: '1px solid black',
  },
  
  // Card-specific constants
  CARDS: {
    COMPACT_WIDTH: 100,
    BORDER_RADIUS_LARGE: '8px',
    BACKDROP_BLUR_LIGHT: 'blur(4px)',
    BACKDROP_BLUR_HEAVY: 'blur(8px)',
    LIFT_TRANSFORM: 'translateY(-2px)',
    SUBTLE_LIFT: 'translateY(-1px)',
    OVERLAY_Z_INDEX: 10,
    TEXT_Z_INDEX: 1,
  }
} as const;

// Type for accessing constants with intellisense
export type UIConstants = typeof UI_CONSTANTS;
